// extracted by mini-css-extract-plugin
export default {"insights-period-select":"Reports_insights-period-select__d-QKD","header-container":"Reports_header-container__+t9Xw"};